import React from 'react'
import { useParams } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import Overview from './Overview'
import Transfers from './Transfers'
import ContentsWrapper from '../../components/organisms/ContentsWrapper'
import { FallBack } from '../../providers/FallBack'
import useTokenDetail from '../../hooks/queries/useTokenDetail'
import MainContentDiv from '../../components/templates/MainContent'
import SearchContainer from '../../components/organisms/SearchContainer'
import Search from '../Search'
import ContentsTitle from '../../components/molecules/ContentsTitle'
import Tabs from '../../components/Tabs'

function TokenDetails() {
  const { address } = useParams() as { address: string }

  const {
    tokenDetails = {
      address: '',
      nameTag: '',
      name: '',
      symbol: '',
      totalSupply: '',
      totalTransfer: 0,
      officialSite: '',
      imageUrl: '',
      isContract: false,
    },
    isLoading,
  } = useTokenDetail(address)

  return (
    <MainContentDiv>
      <SearchContainer>
        <Search />
      </SearchContainer>
      <ContentsTitle title={`${tokenDetails.name} (${tokenDetails.symbol})`} imgUrl={tokenDetails.imageUrl} />
      <Tabs>
        <Tabs.TabList>
          <Tabs.Tab>overview</Tabs.Tab>
          <Tabs.Tab>transfers</Tabs.Tab>
        </Tabs.TabList>
        <Tabs.TabPanels>
          <Tabs.TabPanel>
            <ContentsWrapper>
              <Overview loading={isLoading} tokenDetails={tokenDetails} />
            </ContentsWrapper>
          </Tabs.TabPanel>
          <Tabs.TabPanel>
            <ErrorBoundary fallbackRender={FallBack}>
              <Transfers />
            </ErrorBoundary>
          </Tabs.TabPanel>
        </Tabs.TabPanels>
      </Tabs>
    </MainContentDiv>
  )
}

export default TokenDetails
